
// ajaxzip3 settings
jQuery(document).ready(function ($) {
  // yubinbangoライブラリの有効化(https://github.com/yubinbango/yubinbango)
  $(".mw_wp_form form").addClass("h-adr");

  // エラー箇所にクラス追加
  $("div.form-box:has('span.error')").addClass("form-error");
});

/*
// プライバシーポリシー表示 ajax
jQuery(function ($) {
  $.ajax({
    url: '/privacy',
    cache: false,
    success: function (html) {
      $(html).find('.entry-content').each(function () {
        $('#frame-privarypolicy').html($(this).html());
        return false;
      });
    }
  });
});

// プライバシーポリシー表示 モーダル
jQuery(function ($) {
  $('.js-modal-open').on('click', function () {
    $('.js-modal').fadeIn();
    return false;
  });
  $('.js-modal-close').on('click', function () {
    $('.js-modal').fadeOut();
    return false;
  });
});
*/

// 問い合わせ種別をdisabled、送信時に解除
// jQuery(function ($) {
// 	$('#events-title').attr('readonly',true);
//   $("#contact-type").prop('disabled', true);
// 	$('form').bind('submit', function () {
// 		$(this).find("#contact-type").prop('disabled', false);
// 	});
// });
